import {
    FixedNav,
    Notify,
    Avatar,
    Row,
    Col,
    Divider,
    Cell,
    Switch,
    NoticeBar,
    Dialog,
    Drag,
    Button,
} from '@nutui/nutui-react';
import ConsumptionTaskView from '../components/ConsumptionTaskView';
import { useConsumptionActivity } from '../data/consumptionActivity';
import TeamSection from '../components/TeamSection';
import axios from 'axios';
import { useState, useRef } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { refreshPageWithTimestamp } from '../common';

import 木质宝箱 from '../img/木质宝箱.png';
import 青铜宝箱 from '../img/青铜宝箱.png';
import 黄金宝箱 from '../img/黄金宝箱.png';
import 铂金宝箱 from '../img/铂金宝箱.png';

import 钻石宝箱 from '../img/钻石宝箱.png';
import 招募令 from '../img/招募令.png';
import 黄金鱼竿 from '../img/黄金鱼竿.png';
import 普通鱼竿 from '../img/普通鱼竿.png';

import 金砖 from '../img/金砖.png';
import 图鉴积分 from '../img/图鉴积分.png';

import { bigNumberTransform } from '../common';

const colStyle = { display: 'flex', alignItems: 'center', flexDirection: 'column', marginRight: '20px' };

function Home(props) {
    dayjs.extend(relativeTime);
    dayjs.locale('zh-cn');
    const { user = {}, doDailyCb, updateConfig, notice } = props;
    const { role_info: role = {}, next_schedule, last_schedule } = user;
    // 消耗活动服务器配置：界面显隐完全跟随活动开启状态，无需每期手工改代码
    const { act: consumptionAct } = useConsumptionActivity();

    // const timeArr = user.config.hangUp.hangUpTime.split(":").map(n => parseInt(n, 10))
    const [isRequesting, setIsRequesting] = useState(false);

    // const [searchDialog, setSearchDialog] = useState(false)
    // const [rsDialog, setRsDialog] = useState(false)
    // const [rs, setRs] = useState({})
    // const [gameId, setGameId] = useState("")

    // const [nextSchedule, setNextSchedule] = useState(null)
    // const [lastSchedule, setLastSchedule] = useState(null)

    const _this = useRef({
        lastUpdateConfigTime: 0, // 用于限制10秒内只能切换一次"开启上号"的配置
    }).current;

    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     const { next, last } = getDiffTime({next_schedule, last_schedule})
    //     setNextSchedule(next)
    //     setLastSchedule(last)
    //   }, 1000)
    // }, [])

    const onOpenAutoChanged = () => {
        const currentTime = new Date().getTime();
        if (_this.lastUpdateConfigTime === 0 || currentTime - _this.lastUpdateConfigTime > 10000) {
            user.config.open = !user.config.open;
            setIsRequesting(true);
            updateConfig(user.config, () => {
                setIsRequesting(false);
            });
            _this.lastUpdateConfigTime = new Date().getTime();
        } else {
            Notify.warn(
                `请勿频繁操作, ${10 - Math.trunc((currentTime - _this.lastUpdateConfigTime) / 1000)}秒后可再次操作`,
                { duration: 1000 }
            );
        }
    };

    const doDaily = () => {
        const now = dayjs();
        if (now.get('day') === 5 && now.get('hour') >= 5 && now.get('hour') < 7) {
            Dialog.alert({
                content: '服务器维护时间, 取消立即上号',
                confirmText: '确认',
                // cancelText: '取消',
                lockScroll: false,
                hideCancelButton: true,
                closeOnOverlayClick: true,
            });
            return;
        }

        setIsRequesting(true);
        axios
            .post('/v1/doDaily', { encryptUser: user.encrypt_user })
            .then(({ data }) => {
                if (data.code === 400) {
                    let errMsg;
                    if (data.msg.includes('封禁')) {
                        errMsg = `账号被封禁, 解封时间 ${dayjs.unix(data.body['unLockTime']).format('YYYY-MM-DD HH:mm:ss')}`;
                    } else if (data.msg.includes('账号保护')) {
                        errMsg = `账号被临时保护, 解封时间 ${dayjs.unix(data.body['unLockTime']).format('YYYY-MM-DD HH:mm:ss')}`;
                    }

                    Dialog.alert({
                        content: errMsg,
                        confirmText: '确认',
                        // cancelText: '取消',
                        lockScroll: false,
                        hideCancelButton: true,
                        closeOnOverlayClick: true,
                    });
                    return;
                }

                if (data.code === 201) {
                    if (data.body.type === 'expire') {
                        Notify.warn(`临时卡已过期, 请激活`, { duration: 1000 });
                        return;
                    }
                    if (data.body.type === 'limit') {
                        Dialog.alert({
                            content: data.msg,
                            confirmText: '确认',
                            // cancelText: '取消',
                            lockScroll: false,
                            hideCancelButton: true,
                            closeOnOverlayClick: true,
                        });
                        return;
                    }
                }

                _this.getDailyUserId = setInterval(() => {
                    axios
                        .get('/v1/getDailyUser')
                        .then(({ data }) => {
                            if (data.code === 400) {
                                return;
                            }
                            if (data.code === 200) {
                                doDailyCb();
                            }
                            _this.getDailyUserId && clearInterval(_this.getDailyUserId);
                        })
                        .catch(err => {
                            _this.getDailyUserId && clearInterval(_this.getDailyUserId);
                            refreshPageWithTimestamp();
                        });
                }, 2000);
                // Notify.success("执行成功, 查看上号记录", { duration: 1000 });
            })
            .finally(() => {
                setIsRequesting(false);
            });
    };

    const getTaskLabel = key => {
        const taskLabelMap = {
            arenaTime: '竞技场',
            bottleHelper: '罐子机器人',
            hangUpTime: '挂机奖励',
            tower: '免费爬塔',
            占铜罐子: '占铜罐子',
            铜罐子: '领铜罐子',
            银罐子: '领银罐子',
            金罐子: '领金罐子',
            battleFieldSignUp: '盐场报名',
            legacyHangUp: '功法挂机',
            rateLimitRetry: '限流重试',
        };
        return taskLabelMap[key] || '手动上号';
    };

    const nextDay = dayjs(next_schedule * 1e3);
    const lastDay = dayjs(last_schedule * 1e3);

    const totalSchedule = user.total_schedule;
    const lastTotalSchedule = user.total_schedule.last_total_schedule;
    let lastScheduleLabel = '手动上号',
        nextScheduleLabel;
    for (let key in totalSchedule) {
        let label = getTaskLabel(key);
        if (next_schedule === totalSchedule[key]) {
            nextScheduleLabel = label;
            break;
        }
    }

    let lastScheduleLabels = []; // 记录上次上号做了哪些任务
    if (lastTotalSchedule) {
        for (let key in lastTotalSchedule) {
            if (last_schedule >= lastTotalSchedule[key]) {
                // last_schedule是上次上号的实际时间，此处判断表示上次上号的时刻已经过了该任务的原定计划时间，
                // 那么该任务应该是在上次上号时完成的。但这样也会把某些过期未执行的任务包含在里面，例如12点前
                // 计划排位报名，在过了19:30后才手动上号，实际上没有报名，但也会被包含在上次上号的任务列表中。
                let taskLabel = getTaskLabel(key);
                lastScheduleLabels.push(taskLabel);
            }
        }

        if (lastScheduleLabels.length > 0) {
            lastScheduleLabel = lastScheduleLabels.join('、');
        }
    }

    let serverNameLabel;
    switch (user.role_info.serverName) {
        case '26501服':
            serverNameLabel = `月光宝盒`;
            break;
        case '27001服':
            serverNameLabel = `桃花仙人`;
            break;
        case '27501服':
            serverNameLabel = `生日快乐`;
            break;
        case '28001服':
            serverNameLabel = `二零二五`;
            break;
        case '28501服':
            serverNameLabel = `恭喜发财`;
            break;
        default:
            serverNameLabel = user.role_info.serverName;
            break;
    }

    let legionName = '';
    if (role.legionInfo?.id > 0) {
        const legionPosition = role.legionInfo?.position ? `（${role.legionInfo.position}）` : '';
        legionName = `[${role.legionInfo?.serverName ?? ''}]${role.legionInfo?.name ?? ''}${legionPosition}`;
    }

    document.title = `${user.role_info.name} - ${serverNameLabel} - 咸鱼之王`;

    /**
     * 工具函数：合并连续自然数为范围
     * @param {number[]} arr 自然数列表
     * @returns
     */
    function formatRemainBoss(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return '无';
        const nums = [...arr].sort((a, b) => a - b);
        const result = [];
        let start = nums[0],
            end = nums[0],
            count = 1;
        for (let i = 1; i <= nums.length; i++) {
            if (nums[i] === end + 1) {
                end = nums[i];
                count++;
            } else {
                if (count >= 3) {
                    result.push(`${start}-${end}`);
                } else {
                    for (let j = start; j <= end; j++) result.push(j);
                }
                start = end = nums[i];
                count = 1;
            }
        }
        return result.join(',');
    }

    return (
        <>
            {/* <style>{style}</style> */}

            {notice && <NoticeBar content={notice} />}
            {/* <Avatar src={role.headImg} size='large' /> */}
            <Cell>
                <Row type='flex' wrap='nowrap' align='center'>
                    <Col
                        span='6'
                        className='openAuto'
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center', // 水平居中
                        }}>
                        <p>
                            <Avatar src={role.headImg} size='large' />
                        </p>
                        <p>
                            <Switch
                                onChange={onOpenAutoChanged}
                                checked={user.config.open}
                                activeText='自动上号中'
                                inactiveText='手工上号中'
                                disabled={isRequesting}
                                style={{ float: 'none' }}
                            />
                        </p>
                    </Col>
                    <Col span='8'>
                        <div>
                            <div style={{ marginBottom: '3px' }}>{`${role.name}`}</div>

                            {/* <div style={{ marginBottom: '3px' }}>{``}</div> */}
                            <Divider />
                            <div style={{ marginBottom: '3px' }}>{`生日：${role.createAt ?? ''}`}</div>
                            <Divider />
                            {/* <div style={{ marginBottom: '3px' }}>{`战力: ${bigNumberTransform(user.role_info.power)}`}</div> */}

                            <div style={{ marginBottom: '3px' }}>{`区服：${serverNameLabel}`}</div>
                            {/* <div style={{ marginBottom: '3px' }}>{`VIP: ${user.role_info.vip}`}</div> */}
                            {/* <div style={{ marginBottom: '2px' }}>{`ID: ******${roleId.substring(roleId.length - 3)}`}</div>
              <div>{`服务器: ${"***"}`}</div> */}
                            <Divider />
                            <div style={{ marginBottom: '3px' }}>{`等级：${role.level}`}</div>
                        </div>
                    </Col>
                    <Col span='10'>
                        <div style={{ marginBottom: '3px' }}>{`俱乐部：${legionName}`}</div>
                        <Divider />
                        <div style={{ marginBottom: '3px' }}>{`俱乐部ID：${role.legionInfo?.id ?? ''}`}</div>
                        <Divider />
                        <div style={{ marginBottom: '3px' }}>{`军团币：${role.legionInfo?.legionCoinCnt ?? ''}`}</div>
                        <Divider />
                        <div style={{ marginBottom: '3px' }}>{`Boss：${role.legionInfo?.bossId ?? ''}`}</div>
                        <Divider />
                        <div
                            style={{
                                marginBottom: '3px',
                            }}>{`Boss血量：${bigNumberTransform(role.legionInfo?.bossCurrentHP) ?? ''}`}</div>
                    </Col>
                </Row>
            </Cell>
            <Cell style={{ flexDirection: 'column' }}>
                <Row type='flex' wrap='nowrap' justify='center' align='center'>
                    <Col span='11'>{`下次上号 (${nextScheduleLabel})`}</Col>
                    <Col span='13' style={{ display: 'flex', justifyContent: 'right' }}>
                        {`${nextDay.format('MM月DD号 HH:mm:ss')}`}
                    </Col>
                </Row>
                <Divider />
                <Row type='flex' wrap='nowrap' justify='center' align='center'>
                    <Col span='11'>{`上次上号 (${lastScheduleLabel})`}</Col>
                    <Col span='13' style={{ display: 'flex', justifyContent: 'right' }}>
                        {`${lastDay.format('MM月DD号 HH:mm:ss')}`}
                    </Col>
                </Row>
            </Cell>
            <Button type='info' onClick={doDaily} style={{ width: '100%' }} disabled={isRequesting}>
                立即上号
            </Button>
            <Divider>金鱼资源</Divider>
            <Cell style={{ flexDirection: 'column' }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div style={colStyle}>
                        <Avatar src={木质宝箱} shape='square' size='small' />
                        <div>{role.items?.木质宝箱 ?? 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={青铜宝箱} shape='square' size='small' />
                        <div>{role.items?.青铜宝箱 ?? 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={黄金宝箱} shape='square' size='small' />
                        <div>{role.items?.黄金宝箱 ?? 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={铂金宝箱} shape='square' size='small' />
                        <div>{role.items?.铂金宝箱 ?? 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={钻石宝箱} shape='square' size='small' />
                        <div>{role.items?.钻石宝箱 ?? 0}</div>
                    </div>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div style={colStyle}>
                        <Avatar src={招募令} shape='square' size='small' />
                        <div>{role.items?.招募令 ?? 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={普通鱼竿} shape='square' size='small' />
                        <div>{role.items.普通鱼竿 ?? 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={黄金鱼竿} shape='square' size='small' />
                        <div>{role.items?.黄金鱼竿 ?? 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={金砖} shape='square' size='small' />
                        <div>{role.diamond}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={图鉴积分} shape='square' size='small' />
                        <div>{role?.book?.bookPoint ? role?.book?.bookPoint : 0}</div>
                    </div>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    宝箱积分：{role.packageBoxPoints ?? ''}
                </div>
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                    金鱼：{role.goldenFishes?.length > 0 ? role.goldenFishes.join(', ') : '暂无金色鱼灵'}
                </div>
            </Cell>
            {consumptionAct.open && (
                <>
                    <Divider>{consumptionAct.name}任务进度</Divider>
                    <ConsumptionTaskView role={role} user={user} updateConfig={updateConfig} />
                </>
            )}
            <Divider>阵容</Divider>
            <TeamSection user={user} />

            <Drag
                direction='y'
                style={{ right: '0px', bottom: '40%' }}
                boundary={{ top: 0, left: 0, right: 0, bottom: 0 }}>
                <FixedNav
                    list={[]}
                    activeText='Boss查询'
                    inactiveText='Boss查询'
                    overlay
                    position={{ top: '50%' }}
                    onChange={() => {
                        Dialog.alert({
                            content: (
                                <>
                                    <p>{`昵称：${role.name}`}</p>
                                    <p>
                                        {`历史最高Boss：`}
                                        <span style={{ color: 'red' }}>
                                            {`${role.maxBossId ? role.maxBossId : '还未查询到信息'}`}
                                        </span>
                                    </p>
                                    <p>
                                        {`漏掉的Boss：`}
                                        <span style={{ color: 'red' }}>
                                            {role.remainBoss
                                                ? role.remainBoss.length > 0
                                                    ? formatRemainBoss(role.remainBoss)
                                                    : '无'
                                                : '还未查询到信息'}
                                        </span>
                                    </p>
                                </>
                            ),
                            confirmText: '确认',
                            // cancelText: '取消',
                            lockScroll: false,
                            hideCancelButton: true,
                            closeOnOverlayClick: true,
                        });
                    }}
                />
            </Drag>
            <br />
            <br />
        </>
    );
}

export default Home;
